import { Divider, Drawer, Space, Checkbox, Select, Tooltip, Spin } from "antd";
import React, { useEffect, useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ListSelect from "../../ListSelect";
import { apiCall } from "../../../utils/Api";
import wrap from "../../../utils/wrap";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { tt_name_block_warning, tt_pg_gap_x, tt_pg_gap_y, tt_pg_list, tt_pg_padding_x, tt_pg_padding_y } from "../../../utils/Utils";
import LinkPicker from "../../../globals/styles/LinkPicker";
import MobileSelector from "../../UI/MobileSelector";
export default function ProductGrid(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0, view = "desktop", setView = () => { } } = props;
    const [template,] = useTemplate();
    const [mobile, setMobile] = useState(false)
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        image_size = 120,
        padding_y = 10,
        padding_x = 10,
        gap_y = 10,
        gap_x = 10,
        list_id = "",
        limit = 18,
        show_title = false,
        title_preset = 1,
        show_author = false,
        author_preset = 1,
        background_colour = 0,
        link_id = 0,

        allow_mobile_overrides = false,
        mobile_gap_y = 10,
        mobile_gap_x = 10,
        mobile_padding_y = 0,
        mobile_padding_x = 0,
        mobile_image_size = 120,


    } = data;

    const [items, setItems] = useState({ rows: [], row_count: 0 });


    const getItems = () => {
        if (!list_id) {
            setItems({ rows: [], row_count: 0 });
            return;
        }
        apiCall("titlelist/getItems", { list_id: list_id, limit: 24 }, (_status, _result) => {
            if (_status) {
                setItems(_result);
            }
        })
    }

    useEffect(getItems, [list_id]);

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawItem = (_item) => {
        let _coverStyle = {
            cursor: "pointer"
        }


        return (
            <div style={_coverStyle} key={_item.eisbn}>
                <img className="bm-img-link" onError={(e) => e.target.src = "https://bookmanager.com/i/nocover.png"} style={{ "width": "100%" }} src={"https://bookmanager.com/i/n?b=" + _item.eisbn + "&cb=" + _item.cover_image_cache} />
                <wrap.is value={(show_title)}>
                    <div className="shim" />
                    <div style={{ "display": "block" }} className={"bm-txt-" + title_preset}>{_item.title}</div>
                </wrap.is>
                <wrap.is value={(show_author)}>
                    <div className={"bm-txt-" + author_preset}>{_item.authors.slice(0, 1).map(item => item.name).join(", ")}</div>
                </wrap.is>
            </div>
        )
    }

    const drawPlaceholder = (_index) => {
        return (
            <div key={_index}>
                <img style={{ "width": "100%" }} src={"https://bookmanager.com/i/sample_content/title_placeholder.jpg"} />
                <wrap.is value={(show_title)}>
                    <div className="shim" />
                    <div style={{ "display": "block" }} className={"bm-txt-" + title_preset}>Title</div>
                </wrap.is>
                <wrap.is value={(show_author)}>
                    <div className={"bm-txt-" + author_preset}>Author</div>
                </wrap.is>
            </div>
        )
    }

    const numberToArray = (count) => {
        const resultArray = [];
        for (let i = 1; i <= count; i++) {
            resultArray.push(i);
        }
        return resultArray;
    }

    const drawItems = () => {
        if (items.rows.length === 0) {
            let _arr = numberToArray(limit);
            return _arr.map(item => {
                return drawPlaceholder(item)
            })
        }
        return items.rows.slice(0, limit).map(item => {
            return drawItem(item);
        })
    }

    const drawRender = () => {
        let gridStyle = {
            display: 'grid',
            gridTemplateColumns: `repeat(auto-fill, minmax(${image_size}px, 1fr))`,
            gap: `${gap_y}px ${gap_x}px`,
        };

        let _wrapStyle = {
            padding: `${padding_y}px ${padding_x}px`,
            background: getColor(background_colour, template),
        }

         // mobile 
         if (allow_mobile_overrides && view !== "desktop") {
            gridStyle.gap = `${mobile_gap_y}px ${mobile_gap_x}px`;
            gridStyle.gridTemplateColumns = `repeat(auto-fill, minmax(${mobile_image_size}px, 1fr))`;
            _wrapStyle.padding = `${mobile_padding_y}px ${mobile_padding_x}px`;
         }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={_wrapStyle}>
                    <div style={gridStyle}>
                        {drawItems()}
                    </div>
                    <div className="shim" />
                    <div className="float-flex">
                        <div>&nbsp;</div>
                        <div><a className={"bm-txt-0 bm-lnk-" + link_id}>View all {(items.row_count) ? <>{items.row_count} </> : ""}products</a></div>
                    </div>
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                {/* BACKGROUND PADDING */}
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {(mobile && drawMobile())}
                {(!mobile && drawDesktop())}
            </>
        )
    }

    const drawMobile = () => {
        return (
            <>
                <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                <div className="shim" /><div className="shim" />
                <Spin spinning={!allow_mobile_overrides} indicator={<></>}>
                    {/* PADDING / GAPS */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / GAPS</Divider>
                    <div className="float-flex">
                        <Space>
                            <BMInput width={35} value={mobile_padding_x} onChange={(_v) => setData({ ...data, "mobile_padding_x": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pg_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                            <BMInput width={35} value={mobile_padding_y} onChange={(_v) => setData({ ...data, "mobile_padding_y": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pg_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        </Space>
                        <Space>
                            <BMInput width={35} value={mobile_gap_x} onChange={(_v) => setData({ ...data, "mobile_gap_x": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pg_gap_x}><nobr>GAP X</nobr></Tooltip>} />
                            <BMInput width={35} value={mobile_gap_y} onChange={(_v) => setData({ ...data, "mobile_gap_y": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pg_gap_y}><nobr>GAP Y</nobr></Tooltip>} />
                        </Space>
                    </div>
                    <div className="shim" /> <div className="shim" />

                    {/* SIZE */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SIZE</Divider>
                    <Select value={mobile_image_size} onChange={(e) => setData({ ...data, "mobile_image_size": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%", "fontSize": "11px" }} bordered={true}>
                        <Select.Option key={80} value={80}>X Small (80px)</Select.Option>
                        <Select.Option key={100} value={100}>Small (100px)</Select.Option>
                        <Select.Option key={120} value={120}>Medium (120px)</Select.Option>
                        <Select.Option key={200} value={200}>Large (200px)</Select.Option>
                        <Select.Option key={300} value={300}>X Large (300px)</Select.Option>
                    </Select>
                    <div className="shim" /> <div className="shim" />
                </Spin>
            </>
        )
    }


    const drawDesktop = () => {
        return (
            <>

                {/* LIST */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={tt_pg_list}>MY LIST</Tooltip></Divider>
                <ListSelect value={list_id} onChange={(e) => setData({ ...data, "list_id": e.list_id, "actual_list_id": e.actual_list_id })} />
                <div className="shim" /> <div className="shim" />
                {/* TOGGLE TITLE & AUTHOR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHOW TITLE / AUTHOR</Divider>
                <Space>
                    <Checkbox checked={show_title} onChange={(e) => setData({ ...data, "show_title": e.target.checked })}><small>Show Title</small></Checkbox>
                    <Checkbox checked={show_author} onChange={(e) => setData({ ...data, "show_author": e.target.checked })} ><small>Show Author</small></Checkbox>
                </Space>
                <div className="shim" /> <div className="shim" />
                {/* TITLE TEXT */}
                {(show_title && <>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TITLE PRESET</Divider>
                    <PresetPicker value={title_preset} onChange={(e) => setData({ ...data, "title_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                </>)}
                {/* AUTHOR TEXT */}
                {(show_author && <>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">AUTHOR PRESET</Divider>
                    <PresetPicker value={author_preset} onChange={(e) => setData({ ...data, "author_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                </>)}
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* PADDING / GAPS */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / GAPS</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput width={35} value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pg_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput width={35} value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pg_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                    <Space>
                        <BMInput width={35} value={gap_x} onChange={(_v) => setData({ ...data, "gap_x": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pg_gap_x}><nobr>GAP X</nobr></Tooltip>} />
                        <BMInput width={35} value={gap_y} onChange={(_v) => setData({ ...data, "gap_y": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_pg_gap_y}><nobr>GAP Y</nobr></Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* SIZE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SIZE</Divider>
                <Select value={image_size} onChange={(e) => setData({ ...data, "image_size": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%", "fontSize": "11px" }} bordered={true}>
                    <Select.Option key={80} value={80}>X Small (80px)</Select.Option>
                    <Select.Option key={120} value={120}>Small (120px)</Select.Option>
                    <Select.Option key={200} value={200}>Medium (200px)</Select.Option>
                    <Select.Option key={250} value={250}>Large (250px)</Select.Option>
                    <Select.Option key={290} value={290}>X Large (290px)</Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />
                {/* MAX TITLES */}
                <BMInput value={limit} onChange={(_v) => setData({ ...data, "limit": _v })} number min={4} max={24} prefix="MAX TITLES" />
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />

            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}